/** 个人资料页身份证展示脱敏：前 3 位 + 掩码 + 后 4 位（空值显示「未填写」） */
export const maskIdCard = (val: string | null | undefined): string => {
  if (!val) return '未填写';
  const v = val.trim();
  if (v.length < 8) return v;
  const stars = '•'.repeat(v.length - 7);
  return v.slice(0, 3) + stars + v.slice(-4);
};